export default __webpack_public_path__ + "static/media/Leo_Convert.75f80b48.png";